const routerNames = {
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  CONFIRM_MAIL: 'CONFIRM_MAIL',
  CONFIRM_MAIL_FORGOT: 'CONFIRM_MAIL_FORGOT',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  NEW_PASSWORD: 'NEW_PASSWORD',
  STEP_INFORMATION: 'STEP_INFORMATION',
  STEP_UPLOAD: 'STEP_UPLOAD',
  STEP_PERSPECTIVE_DELIVERY: 'STEP_PERSPECTIVE_DELIVERY',
  STEP_VIEWER: 'STEP_VIEWER',
  STEP_CONFIRMATION: 'STEP_CONFIRMATION',
  STEP_COMPLETED: 'STEP_COMPLETED',
  PLAN: 'PLAN',
  PROJECT: 'PROJECT',
  DETAIL_PROJECT: 'DETAIL_PROJECT',
  FEEDBACK_BACK_PROJECT: 'FEEDBACK_BACK_PROJECT',
  FEEDBACK_BACK_PROJECT_CONFIRM: 'FEEDBACK_BACK_PROJECT_CONFIRM',
  FEEDBACK_BACK_PROJECT_INTRO: 'FEEDBACK_BACK_PROJECT_INTRO',
  CRAFTING_PROJECT: 'CRAFTING_PROJECT',
  CRAFTING_PROJECT_CONFIRM: 'CRAFTING_PROJECT_CONFIRM',
  CREATE_PROJECT: 'CREATE_PROJECT',
  MY_ACCOUNT: 'MY_ACCOUNT',
  MY_ACCOUNT_EDIT_INFO: 'MY_ACCOUNT_EDIT_INFO',
  MY_ACCOUNT_EDIT_PASSWORD: 'MY_ACCOUNT_EDIT_PASSWORD',
  MY_ACCOUNT_CHANGE_EMAIL: 'MY_ACCOUNT_CHANGE_EMAIL',
  MY_ACCOUNT_CHANGE_EMAIL_CONFIRM: 'MY_ACCOUNT_CHANGE_EMAIL_CONFIRM',
  MY_ACCOUNT_LEAVE: 'MY_ACCOUNT_LEAVE',
  MESSAGE: 'MESSAGE'
} as const

export const routerGroups: Record<string, readonly RouteNames[]> = {
  AUTH: [
    routerNames.LOGIN,
    routerNames.REGISTER,
    routerNames.NEW_PASSWORD,
    routerNames.FORGOT_PASSWORD,
    routerNames.CONFIRM_MAIL,
    routerNames.CONFIRM_MAIL_FORGOT
  ],
  PROJECTS: [
    routerNames.PROJECT,
    routerNames.DETAIL_PROJECT,
    routerNames.FEEDBACK_BACK_PROJECT,
    routerNames.FEEDBACK_BACK_PROJECT_CONFIRM,
    routerNames.FEEDBACK_BACK_PROJECT_INTRO,
    routerNames.CRAFTING_PROJECT,
    routerNames.CRAFTING_PROJECT_CONFIRM
  ],
  ACCOUNT: [
    routerNames.MY_ACCOUNT,
    routerNames.MY_ACCOUNT_EDIT_INFO,
    routerNames.MY_ACCOUNT_EDIT_PASSWORD,
    routerNames.MY_ACCOUNT_CHANGE_EMAIL,
    routerNames.MY_ACCOUNT_CHANGE_EMAIL_CONFIRM
  ],
  MESSAGES: [routerNames.MESSAGE],
  PLANS: [routerNames.PLAN]
}

export default routerNames

export type RouteNames = (typeof routerNames)[keyof typeof routerNames]

export const loginPath = '/login'
export const homePath = '/projects'
